import { PERMS } from "./permissions";

export const ROLE_PERMS = Object.freeze({


 
  Admin: [
    PERMS.ADMIN_PANEL_VIEW, // možnost vidět admin panel
    PERMS.STATIONS_LIST_READ, // možnost vidět seznam stanic
    PERMS.STATION_DETAIL_READ, // možnost vidět detail stanice

    PERMS.ARMEX_EDIT,   // upravit armex ceny
    PERMS.ARMEX_CONFIRM, // potvrzovat a odesílat změny u armex
    PERMS.ARMEX_SCHEDULE, // plánovat změny u armex
    PERMS.ARMEX_SNAPSHOT, // zobrazit data z historie
    PERMS.ARMEX_SHOP2000_VIEW, // zobrazit shop2000 data

    PERMS.PLANNED_VIEW, // zobrazit planovane ceny
    PERMS.PLANNED_DELETE, // mazat planovane ceny

    PERMS.NEARBY_EDIT, // psát změny u konkurenčních stanicích
    PERMS.NEARBY_SUBMIT, // odeslat změny u konkurenčních stanicích
    PERMS.USER_CONFIRM_CHANGES, // potvrzovat změny v shopu2000 u nových cenách

    PERMS.USER_ADMIN_PANEL, // možnost vidět uživatelský admin panel
    PERMS.STATION_ADMIN_PANEL,

    PERMS.NEARBY_STATION_PAIR, // parovani stanic 
    PERMS.STATION_USER_ASSIGN, // parovani stanic s uživatelem
    PERMS.STATION_LIMITS_EDIT_DISPLAY, // nastavovani limitu 
    PERMS.ADD_STATION, //přidávání stanic 
    PERMS.STATION_DEACTIVATE, // deaktivace stanic

    PERMS.ARMEX_STATION_EDIT, // změna udaju armex stanic 
    PERMS.NEARBY_STATION_EDIT, // změna udaju nearby stanic 

  ],

  Manager: [
    PERMS.ADMIN_PANEL_VIEW, // možnost vidět admin panel
    PERMS.STATIONS_LIST_READ, // možnost vidět seznam stanic
    PERMS.STATION_DETAIL_READ, // možnost vidět detail stanice
    
    PERMS.ARMEX_EDIT,   // upravit armex ceny
    PERMS.ARMEX_CONFIRM, // potvrzovat a odesílat změny u armex
    PERMS.ARMEX_SCHEDULE, // plánovat změny u armex
    PERMS.ARMEX_SNAPSHOT, // zobrazit data z historie
    PERMS.ARMEX_SHOP2000_VIEW, // zobrazit shop2000 data

    PERMS.PLANNED_VIEW, // zobrazit planovane ceny
    PERMS.PLANNED_DELETE, // mazat planovane ceny

    PERMS.STATION_ADMIN_PANEL,

    PERMS.NEARBY_STATION_PAIR, // parovani stanic 
    PERMS.STATION_USER_ASSIGN, // parovani stanic s uživatelem
    PERMS.STATION_LIMITS_EDIT_DISPLAY, // nastavovani limitu 
    PERMS.ADD_STATION, //přidávání stanic 
    PERMS.STATION_DEACTIVATE, // deaktivace stanic

    PERMS.ARMEX_STATION_EDIT, // změna udaju armex stanic 
    PERMS.NEARBY_STATION_EDIT, // změna udaju nearby stanic 


   
  ],

  Vedouci: [
    PERMS.ADMIN_PANEL_VIEW, // možnost vidět admin panel
    PERMS.STATIONS_LIST_READ, // možnost vidět seznam stanic
    PERMS.STATION_DETAIL_READ, // možnost vidět detail stanice

    PERMS.NEARBY_STATION_PAIR, // parovani stanic 
    PERMS.STATION_USER_ASSIGN, // parovani stanic s uživatelem
    PERMS.ADD_STATION, //přidávání stanic 
    PERMS.STATION_DEACTIVATE, // deaktivace stanic

    PERMS.NEARBY_STATION_EDIT, // změna udaju nearby stanic 

    
    PERMS.NEARBY_EDIT, // psát změny u konkurenčních stanicích
    PERMS.NEARBY_SUBMIT, // odeslat změny u konkurenčních stanicích
    PERMS.USER_CONFIRM_CHANGES, // potvrzovat změny v shopu2000 u nových cenách
  ],

  User: [
    PERMS.STATIONS_LIST_READ, // možnost vidět seznam stanic
    PERMS.STATION_DETAIL_READ, // možnost vidět detail stanice

    PERMS.NEARBY_EDIT, // psát změny u konkurenčních stanicích
    PERMS.NEARBY_SUBMIT, // odeslat změny u konkurenčních stanicích
    PERMS.USER_CONFIRM_CHANGES, // potvrzovat změny v shopu2000 u nových cenách
  ],

   Auditor: [
    PERMS.STATIONS_LIST_READ,
    PERMS.STATION_DETAIL_READ,
  ],

});